import React, { useState, useEffect } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { REACT_APP_API_URL } from "../../../../../env";
import { useSelector } from "react-redux";

const LeaveReports = () => {
    const [reportType, setReportType] = useState("Monthly");
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(""); // NEW
    const [date, setDate] = useState("");
    const [employees, setEmployees] = useState([]);
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState("");
    const { userType, userId } = useSelector((state) => state.auth);

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 20;

    const loadEmployees = async () => {
        try {
            const res = await axios.get(`${REACT_APP_API_URL}api/hrms/report/employees`);
            setEmployees(res.data.success ? res.data.data : []);
        } catch (err) {
            console.error("Employee Fetch Error:", err);
            setEmployees([]);
        }
    };

    useEffect(() => {
        loadEmployees();
    }, []);

    useEffect(() => {
        if (userType === "hrms" && userId) {
            setSelectedEmployee(userId);
        }
    }, [userType, userId]);

    // Fetch Report
    const handleFetchReport = async () => {
        setLoading(true);
        setReportData([]);
        setCurrentPage(1);

        try {
            const params = { reportType };

            if (["Monthly", "Yearly", "Balance"].includes(reportType)) {
                params.year = year;
            }

            if (reportType === "Monthly" && month) {
                params.month = month;
            }

            if (reportType === "Daily") {
                params.date = date;
            }

            if (userType === "hrms") {
                params.empCode = userId;
            } else if (selectedEmployee) {
                params.empCode = selectedEmployee;
            }


            const res = await axios.get(
                `${REACT_APP_API_URL}api/hrms/report/employees-leave-report`,
                {
                    params,
                    withCredentials: true,
                }
            );

            setReportData(res.data.success ? res.data.data : []);
        } catch (err) {
            console.error("Leave Report API Error:", err);
            setReportData([]);
        }

        setLoading(false);
    };

    // Pagination logic
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = reportData.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(reportData.length / recordsPerPage);

    // Export Excel
    const exportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(reportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "LeaveReport");
        XLSX.writeFile(workbook, "Leave_Report.xlsx");
    };

    // Export PDF
    const exportPDF = () => {
        const doc = new jsPDF("l", "pt", "a4");
        doc.text("Leave Report", 40, 40);

        const columns = Object.keys(reportData[0] || {});
        const rows = reportData.map((item) => Object.values(item));

        doc.autoTable({
            head: [columns],
            body: rows,
            startY: 60,
            styles: { fontSize: 8 },
        });

        doc.save("Leave_Report.pdf");
    };

    const LEAVE_REPORT_COLUMNS = {
        Monthly: [
            { key: "EmployeeID", label: "Employee ID" },
            { key: "EmployeeName", label: "Employee Name" },
            { key: "MonthName", label: "Month" },
            { key: "LeaveType", label: "Leave Type" },
            { key: "NoOfLeaves", label: "No. of Leaves" },
            { key: "DaysTaken", label: "Days Taken" },
        ],

        Daily: [
            { key: "EmployeeID", label: "Employee ID" },
            { key: "EmployeeName", label: "Employee Name" },
            { key: "LeaveType", label: "Leave Type" },
            { key: "StartDate", label: "Start Date" },
            { key: "EndDate", label: "End Date" },
            { key: "Status", label: "Status" },
        ],

        Yearly: [
            { key: "EmployeeID", label: "Employee ID" },
            { key: "EmployeeName", label: "Employee Name" },
            { key: "LeaveType", label: "Leave Type" },
            { key: "NoOfLeaves", label: "Total Leaves" },
            { key: "TotalDaysTaken", label: "Total Days Taken" },
        ],

        Balance: [
            { key: "EmployeeID", label: "Employee ID" },
            { key: "EmployeeName", label: "Employee Name" },
            { key: "LeaveType", label: "Leave Type" },
            { key: "TotalEntitled", label: "Total Entitled" },
            { key: "DaysTaken", label: "Days Taken" },
            { key: "BalanceLeaves", label: "Balance Leaves" },
        ],

    };
    const columns = LEAVE_REPORT_COLUMNS[reportType] || [];

    return (
        <div className="container mt-4 mb-5">
            <h3 className="text-primary fw-bold mb-4 text-center">
                HRMS Leave Reports
            </h3>

            {/* Filters */}
            <div className="card sticky-top p-3 shadow-sm">
                <div className="row">

                    {/* Report Type */}
                    <div className="col-md-4 mb-3">
                        <label className="fw-semibold">Report Type</label>
                        <select
                            className="form-select"
                            value={reportType}
                            onChange={(e) => {
                                setReportType(e.target.value);
                                setMonth("");
                                setDate("");
                            }}
                        >
                            <option value="Monthly">Monthly</option>
                            <option value="Daily">Daily</option>
                            <option value="Yearly">Yearly</option>
                            <option value="Balance">Balance</option>
                        </select>
                    </div>

                    {/* Year */}
                    {(reportType === "Monthly" ||
                        reportType === "Yearly" ||
                        reportType === "Balance") && (
                            <div className="col-md-4 mb-3">
                                <label className="fw-semibold">Year</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={year}
                                    onChange={(e) => setYear(e.target.value)}
                                />
                            </div>
                        )}

                    {/* Month (ONLY Monthly) */}
                    {reportType === "Monthly" && (
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold">Month</label>
                            <select
                                className="form-select"
                                value={month}
                                onChange={(e) => setMonth(e.target.value)}
                            >
                                <option value="">-- All Months --</option>
                                {Array.from({ length: 12 }, (_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                        {new Date(0, i).toLocaleString("default", { month: "long" })}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Daily Date */}
                    {reportType === "Daily" && (
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold">Date</label>
                            <input
                                type="date"
                                className="form-control"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                            />
                        </div>
                    )}

                    {/* Employee */}
                    {userType !== "hrms" && (
                        <div className="col-md-4 mb-3">
                            <label className="fw-semibold">Employee</label>
                            <select
                                className="form-select"
                                value={selectedEmployee}
                                onChange={(e) => setSelectedEmployee(e.target.value)}
                            >
                                <option value="">-- Select Employee --</option>
                                {employees.map((emp) => (
                                    <option key={emp.intUserId} value={emp.intUserId}>
                                        {emp.vchFullName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}

                    {/* Show Button */}
                    <div className="col-md-4 mb-3 d-flex align-items-end">
                        <button className="btn btn-primary w-100" onClick={handleFetchReport}>
                            Show
                        </button>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="card p-3 shadow-sm mt-4">
                <div className="d-flex justify-content-between mb-3">
                    <h5 className="fw-bold text-secondary">Report Data</h5>

                    {reportData.length > 0 && (
                        <div>
                            <button className="btn btn-success me-2" onClick={exportExcel}>
                                Export Excel
                            </button>
                            <button className="btn btn-danger" onClick={exportPDF}>
                                Export PDF
                            </button>
                        </div>
                    )}
                </div>

                {loading ? (
                    <p className="text-center text-primary fw-bold">Loading...</p>
                ) : (
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                            <thead className="table-info sticky-top">
                                <tr>
                                    {columns.map((col) => (
                                        <th key={col.key}>{col.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {currentRecords.length === 0 ? (
                                    <tr>
                                        <td colSpan="20" className="text-center text-danger fw-bold">
                                            No Records Found
                                        </td>
                                    </tr>
                                ) : (
                                    currentRecords.map((row, i) => (
                                        <tr key={i}>
                                            {columns.map((col) => (
                                                <td key={col.key}>{row[col.key]}</td>
                                            ))}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* Pagination */}
                {reportData.length > 0 && (
                    <div className="d-flex justify-content-between mt-3">
                        <button
                            className="btn btn-outline-primary"
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                        >
                            Previous
                        </button>
                        <span className="fw-bold">
                            Page {currentPage} of {totalPages}
                        </span>
                        <button
                            className="btn btn-outline-primary"
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default LeaveReports;
